import Cookies from 'js-cookie';

/**
 * ConditionalLayer module implementation.
 *
 * @author Daniel Koch (https://danielkoch.de)
 * @namespace Tc.Module
 * @class ConditionalLayer
 * @extends Tc.Module
 */
T.Module.ConditionalLayer = T.createModule({

	_attributes: {},
	_configs: {
		scrollToDelay: 0,
	},
	_selectors: {
		closeButton: '[data-js-m-conditional-layer-close-layer]',
	},
	_eventNames: {
		CLICK: 'click',
	},
	_stateClasses: {
		isActive: 'm-conditional-layer--is-active',
		isKickedOut: 'm-conditional-layer--is-kicked-out',
	},

	start: function(resolve) {
		this.$ctx = $(this._ctx);
		const $closeButton = this.$ctx.find(this._selectors.closeButton);

		$closeButton.on(this._eventNames.CLICK, () => {
			this.createCookie();
		});

		this.checkCookie();

		resolve();
	},
	sync() {
		// Called when start() method of all registered modules was called.
	},

	checkCookie: function() {
		if (Cookies.get('ConditionalLayer') !== 'set') {
			this.$ctx.addClass(this._stateClasses.isActive);
		}
	},
	createCookie: function() {
		Cookies.set('ConditionalLayer', 'set', {
			expires: 365,
			path: '/',
			// secure: true,
		});
		this.$ctx.addClass(this._stateClasses.isKickedOut);
	},
});

export default T.Module.ConditionalLayer;
